export const fetchTalents = async () => {
  const page = 1;
  const pageSize = 5;
  try {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/main/list/public-talents?page=${page}&page_size=${pageSize}`,
      {
        method: "GET",
      }
    );
    if (!res.ok) {
      throw new Error("Something went wrong in fetching talents");
    }
    const data = await res.json();
    return data;
  } catch (err) {
    console.error("There was a problem with the fetch talents", err);
    throw err;
  }
};
